import React from 'react';
import { Search } from 'lucide-react';
import PropTypes from 'prop-types';

const SearchInputV2 = ({ value, onChange, placeholder = "Search...", className = "" }) => {
    return (
        <div className={`search-v2 ${className}`}>
            <div className="search-wrapper">
                <Search className="oct_icon-search" />
                <input
                    type="text"
                    className="oct_input-search-v2"
                    placeholder={placeholder}
                    value={value || ''}
                    onChange={onChange}
                />
            </div>
        </div>
    );
};

SearchInputV2.propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
    className: PropTypes.string
};

export default SearchInputV2;
